<section class="playground">
  <h2 class="playground__heading">Input preview</h2>
  <p class="playground__hint">
    <code>common-input-preview</code> — fila de solo lectura con icono leading, etiqueta, valor y botón de edición.
  </p>

  <div class="playground__grid">
    <div class="playground__controls">
      <label class="playground__field">
        <span>value</span>
        <input type="text" [(ngModel)]="value" />
      </label>

      <label class="playground__field">
        <span>label</span>
        <input type="text" [(ngModel)]="label" />
      </label>

      <label class="playground__field playground__field--checkbox">
        <input type="checkbox" [(ngModel)]="showLabel" />
        <span>showLabel</span>
      </label>

      <label class="playground__field playground__field--checkbox">
        <input type="checkbox" [(ngModel)]="showLeadingIcon" />
        <span>showLeadingIcon</span>
      </label>

      <label class="playground__field">
        <span>leadingIcon (ligature)</span>
        <input type="text" [(ngModel)]="leadingIcon" placeholder="person" />
      </label>

      <label class="playground__field playground__field--checkbox">
        <input type="checkbox" [(ngModel)]="showEditIcon" />
        <span>showEditIcon</span>
      </label>
    </div>

    <div class="playground__preview">
      <p class="playground__preview-title">Preview</p>
      <div class="playground__preview-box">
        <common-input-preview
          [value]="value"
          [label]="label"
          [showLabel]="showLabel"
          [showLeadingIcon]="showLeadingIcon"
          [leadingIcon]="leadingIcon"
          [showEditIcon]="showEditIcon"
          (edit)="onEdit()"
        ></common-input-preview>
      </div>

      <p *ngIf="lastEvent" class="playground__meta">{{ lastEvent }}</p>
    </div>
  </div>
</section>
